import { IFCWithChildren } from '~/interfaces/i-fc-with-children';

import { PageContainerWrapper } from './styles';

export const PageContainer: IFCWithChildren = ({ children }) => (
  <PageContainerWrapper>
    <div>{children}</div>
  </PageContainerWrapper>
);
